<template>
  <div class="container userSettings">
    <h1 class="title">{{ $t("user.title") }}</h1>

    <h2 class="subtitle">{{ $t("user.subtitle") }}</h2>
    <div class="columnsContainer">
      <div class="columns">
        <div class="column">
          <b-field :label="$t('login.email')">
            <b-input disabled :value="user.email"></b-input>
          </b-field>
        </div>

        <div class="column">
          <b-field :label="$t('user.name')">
            <b-input v-model="form.name"></b-input>
          </b-field>
        </div>

        <div class="column">
          <b-field :label="$t('user.lastName')">
            <b-input v-model="form.lastName"></b-input>
          </b-field>
        </div>
      </div>

      <button
        v-bind:class="{ 'is-loading': isUpdatingUser }"
        class="button is-success"
        :disabled="!isUserValid"
        @click="updateUser"
      >
        {{ $t("buttons.save") }}
      </button>
    </div>

    <h2 class="subtitle">{{ $t("user.changePassword") }}</h2>
    <div class="columnsContainer">
      <div class="columns is-multiline">
        <div class="column">
          <b-field :label="$t('user.oldPassword')">
            <b-input type="password" v-model="password.oldPassword"></b-input>
          </b-field>
        </div>

        <div class="column">
          <b-field :label="$t('user.newPassword')">
            <b-input type="password" v-model="password.newPassword"></b-input>
          </b-field>
        </div>

        <div class="column">
          <b-field :label="$t('user.newPasswordRepeat')">
            <b-input
              type="password"
              v-model="password.newPasswordRepeat"
            ></b-input>
          </b-field>
        </div>

        <div class="column is-12">
          <h4 style="text-align: center; color: red">{{ passwordError }}</h4>
        </div>
      </div>

      <button
        v-bind:class="{ 'is-loading': isUpdatingPassword }"
        class="button is-success"
        :disabled="!isPasswordValid"
        @click="changePassword"
      >
        {{ $t("buttons.update") }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "user",
  data() {
    return {
      passwordError: "",
      isUpdatingUser: false,
      isUpdatingPassword: false,

      form: {
        name: "",
        lastName: "",
      },

      password: {
        oldPassword: "",
        newPassword: "",
        newPasswordRepeat: "",
      },
    };
  },
  computed: {
    ...mapState("user", {
      user: "current",
    }),

    isUserValid: function () {
      return this.form.name.length > 0 && this.form.lastName.length > 0;
    },

    isPasswordValid: function () {
      return (
        this.password.oldPassword.length > 0 &&
        this.password.newPassword.length > 0 &&
        this.password.newPasswordRepeat.length > 0 &&
        this.password.newPassword === this.password.newPasswordRepeat &&
        this.password.oldPassword !== this.password.newPassword
      );
    },
  },
  methods: {
    ...mapActions("user", {
      update: "updateUser",
      updatePassword: "updatePassword",
    }),

    updateUser: function () {
      this.isUpdatingUser = true;

      this.update(this.form).then(() => {
        this.isUpdatingUser = false;
      });
    },

    changePassword: function () {
      this.isUpdatingPassword = true;
      this.passwordError = "";

      this.updatePassword(this.password)
        .catch((error) => {
          this.passwordError = error;
        })
        .then(() => {
          this.isUpdatingPassword = false;
        });
    },
  },

  mounted() {
    this.form.name = this.user.firstname;
    this.form.lastName = this.user.lastname;
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 100%;
}
.columnsContainer {
  margin-bottom: 3rem;
}
.userSettings {
  padding: 0 2rem 2rem;
}

h1.title {
  margin: 3rem 0 5rem;
}
</style>
